// extracted by mini-css-extract-plugin
module.exports = {"walletFaq":"WalletFaq_walletFaq__tqcAF","faqContainer":"WalletFaq_faqContainer__3eFEC"};